import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { COMMERCIAL_SUPPLIER_SORT_DIRECTIONS } from './constants';

export function getCommercialSupplierSortAnnouncement(label, direction) {
  if (direction === COMMERCIAL_SUPPLIER_SORT_DIRECTIONS.asc) {
    return `${label} sorted ascending.`;
  }

  if (direction === COMMERCIAL_SUPPLIER_SORT_DIRECTIONS.desc) {
    return `${label} sorted descending.`;
  }

  return `${label} returned to default order.`;
}

export function getCommercialSupplierSortSprite(isActive, direction) {
  if (!isActive) {
    return 'SortDefault';
  }

  return direction === COMMERCIAL_SUPPLIER_SORT_DIRECTIONS.asc ? 'SortAsc' : 'SortDesc';
}

export function getCommercialSupplierAriaSort(isActive, direction) {
  if (!isActive) {
    return undefined;
  }

  return direction === COMMERCIAL_SUPPLIER_SORT_DIRECTIONS.asc ? 'ascending' : 'descending';
}

function SubstanceCommercialSupplierSortHeaderButton({ className, dataE2e, isActive, label, onSort, direction }) {
  return (
    <ButtonWithIcon
      data-e2e={dataE2e}
      type="link"
      iconRight
      linkIconSize="xs"
      sprite={getCommercialSupplierSortSprite(isActive, direction)}
      className={className}
      aria-pressed={isActive}
      onClick={onSort}>
      {label}
    </ButtonWithIcon>
  );
}

SubstanceCommercialSupplierSortHeaderButton.propTypes = {
  className: PropTypes.string,
  dataE2e: PropTypes.string.isRequired,
  direction: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
};

export default SubstanceCommercialSupplierSortHeaderButton;
